import { useMemo } from 'react';
import { useClientAssociatedProfilesQuery } from '../../../api/useClientAssociatedProfilesQuery';

export const useClientAssociatedProfiles = ({
  clientId,
  isOrionClient,
}: {
  clientId: string;
  isOrionClient: boolean;
}) => {
  const queryInfo = useClientAssociatedProfilesQuery({ clientId, enabled: isOrionClient });

  const data = useMemo(() => {
    if (!queryInfo.data) {
      return null;
    }

    return queryInfo.data.map(household => ({
      text: household.Name,
      id: household.Id,
      selected: household.Selected,
      icon: 'far fa-check',
    }));
  }, [queryInfo]);

  return {
    ...queryInfo,
    data,
  };
};
